import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ProjectService } from 'src/app/services/project.service';
import { Project } from 'src/app/shared/models/project.model';

@Component({
    selector: 'app-project-content',
    templateUrl: './project-content.component.html',
    styleUrl: './project-content.component.scss',
    standalone: false
})
export class ProjectContentComponent implements OnInit {
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('descriptionModal') descriptionModal!: TemplateRef<any>;
	@ViewChild('removeDescriptionModal') removeDescriptionModal!: TemplateRef<any>;
	@ViewChild('deleteProjectModal') deleteModal!: TemplateRef<any>;

	overview = '';
	currentProject!: Project;
	projectObserve!: Observable<Project>;
	projects: Project[] = [];
	currentProjectID!: number;
	currenttab = 1;
	isOwner = false;
	editMode = false;
	modalType = '';

	description: string | null = null;

	deleteModalRef: any;
	descriptionModalRef: any;
	removeDescriptionModalRef: any;
	submitted = false;
	spinner = false;
	success = false;
	error = false;
	message = '';
	current_client: any = null;

	successMessage = '';

	projectListWidgets!: any;
	teamOverviewList: any;

	constructor(private projectService: ProjectService, private modalService: NgbModal, private route: ActivatedRoute, public authService: AuthService, private router: Router) {
		this.projectObserve = this.projectService.project$;

		this.projectObserve.subscribe((project: any) => {
      this.currentProject = project;
    });

		this.route.params.subscribe((params: any) => {
			this.currentProjectID = Number(params.projectid);
			this.currentProject = this.projectService.getProject();

			if (this.currentProject) {
				if (this.currentProjectID !== this.currentProject.id) {
					this.setCurrentProject();
				}
			} else {
				this.setCurrentProject();
			}

			this.route.queryParams.subscribe((queryParams: any) => {
				this.currenttab = this.returnCurrentTab(queryParams.tab);
			})
		});
	}

	setCurrentProject() {
		const projects = this.projectService.getProjectsList();
		const project = this.findProjectIdInTree(projects, this.currentProjectID);

		if(project) {
			this.projectService.setProject(project);
		} else {
			this.router.navigate(['projects']);
		}
	}

	findProjectIdInTree(tree: Project[], targetProjectId: number): Project | null {
    for (const project of tree) {
      if (project.id === targetProjectId) {
        return project; // Found the project!
      }
      
      if (project.children && project.children.length > 0) {
        const foundInChildren = this.findProjectIdInTree(project.children, targetProjectId);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return null; // Project ID not found in this tree
  }

	ngOnInit(): void {
		this.current_client = this.authService.currentClientValue;
		this.isOwner = this.authService.currentClientValue.roles.includes('OWNER') || false;
	}

	returnCurrentTab(tab: string): number {
		switch (tab) {
			case 'overview':
				return 1;
			case 'assessments':
				return 7;
			case 'conversations':
				return 2;
			case 'questionnaires':
				return 3;
			case 'examinees':
				return 5;
			case 'team':
				return 6;
			default:
				return 1;
		}
	}

	changeTab(tabName: string) {
		if (tabName === 'overview') {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: { }
			});
		} else {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: { tab: tabName },
				queryParamsHandling: 'merge'
			});
		}
	}

	findProjectById(projs: Project[], targetId: number): any | null {
		for (const proj of projs) {
			if (proj.id === targetId) {
				return proj;
			}
	
			if (proj.children && proj.children.length > 0) {
				const found = this.findProjectById(proj.children, targetId);
				if (found) {
					return found;
				}
			}
		}
	
		return null;
	}

	openDescriptionModal(edit?: boolean) {
		this.description = null;
		this.editMode = false;

		if (this.currentProject.description) {
			this.editMode = true;
			this.description = this.currentProject.description;
		}

		this.descriptionModalRef = this.modalService.open(this.descriptionModal, { size: 'xl', backdrop: 'static', keyboard : false });
	}

	openRemoveDescriptionModal() {
		this.removeDescriptionModalRef = this.modalService.open(this.removeDescriptionModal, { size: 'xl', backdrop: 'static', keyboard : false });
	}

	saveDescription(remove?: boolean) {
		this.submitted = true;
		this.spinner = true;

		if (remove) {
			this.description = null;
		}

		this.projectService.updateProject(this.currentProject.id, { description: this.description }).subscribe({
			next: () => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.successMessage = 'Description Saved successfully.';
				this.descriptionModalRef.close();
				if (remove) {
					this.removeDescriptionModalRef.close();
				}
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.successMessage = 'Description can not be saved!';
				this.message = err.message ? err.message : err;

				if (remove) {
					this.removeDescriptionModalRef.close();
				}
				
				this.descriptionModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}

	toggleSidebar(event: boolean) {
		this.projectService.setLeftSideBar(event)
	}

	openDeleteProjectModal() {
		this.deleteModalRef = this.modalService.open(this.deleteModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	deleteProject() {
		this.submitted = true;
		this.spinner = true;
		this.modalType = 'delete';

		this.projectService.deleteProject(this.currentProject.id).subscribe({
			next: () => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.successMessage = 'Project has been deleted successfully.';
				this.deleteModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.successMessage = 'Project can not be deleted!';
				this.message = err;

				this.deleteModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}

	async closeModal() {
		if (this.success) {
			if (this.modalType === 'delete') {
				await this.projectService.getProjects();
				const projects = this.projectService.getProjectsList();
				this.router.navigate(['/projects']);
				this.projectService.setProject(projects[0]);
			} else {
				this.projectService.loading = true;
				await this.projectService.getProjects();
				this.setCurrentProject();
			}
		}
		
		this.modalService.dismissAll();
	}
}
